module.exports = __webpack_public_path__ + "img/thumb_09.011a48a1.jpg";